import React from 'react';
import { useTranslation } from 'react-i18next';

const StakesPanel = ({
  portfolio,
  activeStakes,
  onStake,
  onMoreDetails,
  onUnstakeCard,
}) => {
  const { t } = useTranslation();

  return (
    <div className="staking-panel">
      <section className="staking-sheet">
        <section className="staking-hero staking-hero--tvl">
          <p className="staking-hero-label">
            {t('staking.total_value_locked', 'Total Value Locked')}
          </p>
          <p className="staking-hero-value">{portfolio.totalValueLocked}</p>
        </section>

        <div className="staking-stats-row">
          <div className="staking-stat-card">
            <p className="staking-stat-label">{t('staking.my_stakes', 'My Stakes')}</p>
            <p className="staking-stat-value staking-stat-value--accent">
              {portfolio.myStakesTotal}
            </p>
          </div>
          <div className="staking-stat-card">
            <p className="staking-stat-label">{t('staking.my_share', 'My Share')}</p>
            <p className="staking-stat-value staking-stat-value--accent">
              {portfolio.mySharePercent}%
            </p>
          </div>
        </div>

        <button type="button" className="staking-btn staking-btn-primary staking-btn-block" onClick={onStake}>
          {t('staking.stake_cta', 'Stake')}
        </button>

        <section className="staking-section staking-section--active">
          <h3 className="staking-section-title">
            {t('staking.active_stakes', 'Active stakes')}
          </h3>
          <ul className="staking-card-list staking-stake-cards-grid">
            {activeStakes.map((row) => (
              <li key={row.id} className="staking-stake-card">
                <p className="staking-stake-amount">{row.amount}</p>
                <div className="staking-stake-meta">
                  <span>
                    {t('staking.stake_date', 'Stake date')}: {row.stakeDate}
                  </span>
                  <span>
                    {t('staking.due_date', 'Due date')}: {row.dueDate}
                  </span>
                </div>
                <div className="staking-stake-actions staking-stake-actions--col">
                  <button
                    type="button"
                    className="staking-link-btn staking-link-btn--external"
                    onClick={() => onMoreDetails(row.id)}
                  >
                    {t('staking.more_details', 'More details')}
                    <span className="staking-ext-icon" aria-hidden>
                      ↗
                    </span>
                  </button>
                  <button
                    type="button"
                    className="staking-btn staking-btn-secondary staking-btn--compact"
                    onClick={() => onUnstakeCard(row)}
                  >
                    {t('staking.unstake', 'Un-Stake')}
                  </button>
                </div>
              </li>
            ))}
          </ul>
        </section>
      </section>
    </div>
  );
};

export default StakesPanel;
